import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import { SalesOrderService } from "../../../services/salesOrder.service";
import {
  Combo2Service,
  ExcelService,
  PurchaseReportService,
} from "../../../services/index";
declare var google;

@Component({
  selector: "shirt-stock-report",
  templateUrl: "./shirtStockReport.html",
})
export class shirtStockReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  gridOptions: any;
  dataList = [];
  qualityList: any;
  typeList: any;
  backbutExists: boolean = false;
  columnList = [];
  codeList: any;
  widthList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  finyearList = [];
  groupbyList = ["ALLPARTY VIEW", "NORMAL VIEW"];
  filter = {
    groupby: "total_stock",
    style: "",
    stock_type: "total_stock",
    variety: "",
    design: "",
    design_color: "",
    type: "",
    agent_id: "",
    party_id: "",
    destype: "",
    invoice_id: "",
    outward_type: "",
    aoid: "",
    menu_param: "",
    incharger: "",
    agent_name: "",
    dc_no: "",
    party_name: "",
    dcid: "",
    view_type:""
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "po_no",
    orderDir: "asc",
  };
  printConfig: any = {
    title: "Open Order Report",
    columns: [],
    rows: [],
  };

  colorList = [
    "lightcyan",
    "bisque",
    "lightblue",
    "lightgoldenrodyellow",
    "thistle",
    "floralwhite",
    "#fbd4da",
    "#f2cd75",
    "lightgrey",
    "#ccebcc"
  ];

  partyList = [];
  exceldata: any;

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  columns = [];
  partycodeList = [];
  toggleCol = [];
  menu: any;
  reportTypeList = ["DESIGN NO", "PARTY", "PURCHASE"];
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  swatchList = ["YES", "NO"];
  sampList = ["YES", "NO"];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  group1 = {
    total_pcs: 0,
    total_value: 0,
  };
  group2 = {
    total_pcs: 0,
    total_value: 0,
  };
  group3 = {
    total_pcs: 0,
    total_value: 0,
  };
  constructor(
    public store: Store<fromRootStore.State>,
    private excelService: ExcelService,
    private purReport: PurchaseReportService,
    public datePipe: DatePipe,
    private combo2Service: Combo2Service,
    private salesOrderServ: SalesOrderService,
    public toasterService: ToasterService
  ) { }

  ngOnInit(): void {
    this.getColumns();
    this.finyearCombo();
    this.toggleCol = Object.assign({}, this.columns);

    this.filter.menu_param = this.menu.param;
  }

  hotkeys(event) {
    if (this.active) {
    }
  }
  backbutton() {
    if ($(".data-history-btn").length) {
      this.backbutExists = false;
    } else {
      this.backbutExists = true;
    }
  }
  getColumns() {
    this.columns = [];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  onCellClick(event) {
    let row = event.row;
    if (this.filter.groupby == "total_stock") {
      row = event;
    }

    if (this.filter.groupby == "total_stock") {
      // setTimeout(() => {
      this.filter.stock_type = row.stock_type;
      // },0);
    }

    if (this.filter.stock_type == "SETWISE") {
      if (this.filter.groupby == "total_stock") {
        this.filter.style = row.TYPE;
        this.filter.groupby = "variety";
      } else if (this.filter.groupby == "variety") {
        this.filter.groupby = "design";
        this.filter.variety = row.type;
      } else if (this.filter.groupby == "design") {
        this.filter.groupby = "designColor";
        this.filter.design = row.design_no;
      } else if (this.filter.groupby == "designColor") {
        this.filter.groupby = "barcode";
        this.filter.design_color = row.shade;
      }
    } else if (
      this.filter.stock_type == "COREGANG" ||
      this.filter.stock_type == "DAMAGE"
    ) {
      if (this.filter.groupby == "total_stock") {
        this.filter.type = row.TYPE;
        this.filter.groupby = "style";
      } else if (this.filter.groupby == "style") {
        this.filter.groupby = "variety";
        this.filter.destype = row.destype;
        this.filter.style = row.style;
      } else if (this.filter.groupby == "variety") {
        this.filter.groupby = "design";
        this.filter.variety = row.type;
      }
      else if (this.filter.groupby == "design") {
        this.filter.groupby = "designColor";
        this.filter.design = row.design_no;
      } else if (this.filter.groupby == "designColor") {
        this.filter.groupby = "barcode";
        this.filter.design_color = row.shade;
      }
    }
    else if (this.filter.stock_type == "CLUB") {
      if (this.filter.groupby == "total_stock") {
        this.filter.groupby = "design";
      }
      else if (this.filter.groupby == "design") {
        this.filter.groupby = "designColor";
        this.filter.design = row.design_no;
      } else if (this.filter.groupby == "designColor") {
        this.filter.groupby = "barcode";
        this.filter.design_color = row.shade;
      }
    }
    else if (this.filter.stock_type == "OLIVE") {
      if (this.filter.groupby == "total_stock") {
        this.filter.groupby = "barcode";
      }
    }
    else if (this.filter.stock_type == "LIMIT STOCK") {
      if (this.filter.groupby == "total_stock") {
        this.filter.groupby = "barcode";
      }
    }
    else if (this.filter.stock_type == "SPECIAL GOODS") {
      if (this.filter.groupby == "total_stock") {
        this.filter.groupby = "barcode";
      }
    }
    else if (this.filter.stock_type == "LE MERITIN") {
      if (this.filter.groupby == "total_stock") {
        this.filter.groupby = "barcode";
      }
    }
    else if (this.filter.stock_type == "MARX") {
      if (this.filter.groupby == "total_stock") {
        this.filter.groupby = "barcode";
      }
    }
    else if (this.filter.stock_type == "BABLA") {
      if (this.filter.groupby == "total_stock") {
        this.filter.groupby = "barcode";
      }
    }
    else if (this.filter.stock_type == "RETURNBUNDLESTOCK") {
      if (this.filter.groupby == "total_stock") {
        this.filter.groupby = "bundle_entry";
      }
    } else if (
      this.filter.stock_type == "ESTIMATEBUNDLESTOCK" ||
      this.filter.stock_type == "ESTIMATESTOCK"
    ) {
      if (this.filter.groupby == "total_stock") {
        this.filter.groupby = "agent";
      } else if (this.filter.groupby == "agent") {
        this.filter.groupby = "party";
        this.filter.agent_id = row.agent_id;
      } else if (this.filter.groupby == "party") {
        this.filter.groupby = "invoice";
        this.filter.party_id = row.party_id;
      } else if (this.filter.groupby == "invoice") {
        this.filter.groupby = "barcode";
        this.filter.invoice_id = row.invoice_id;
      }
    } else if (this.filter.stock_type == "IOSTOCK") {
      if (this.filter.groupby == "total_stock") {
        this.filter.groupby = "stock_outward";
      } else if (this.filter.groupby == "stock_outward") {
        this.filter.groupby = "stockType";
        this.filter.outward_type = row.type;
      } else if (this.filter.groupby == "stockType") {
        this.filter.groupby = "stockBarcodeType";
        this.filter.aoid = row.aoid;
      }
    } else if (this.filter.stock_type == "SIZEWISE") {
      if (this.filter.groupby == "total_stock") {
        this.filter.style = row.TYPE;
        this.filter.groupby = "design";
      } else if (this.filter.groupby == "design") {
        this.filter.groupby = "designColor";
        this.filter.design = row.design_no;
      } else if (this.filter.groupby == "designColor") {
        this.filter.groupby = "barcode";
        this.filter.design_color = row.shade;
      }
    }
    else if (this.filter.stock_type == "COUNTER STOCK" || this.filter.stock_type == "COUNTERDC INWARD PENDING") {
      if (this.filter.groupby == "total_stock") {
        this.filter.groupby = "teamwise";
      }
      else if (this.filter.groupby == "teamwise" && this.filter.view_type == 'ALLPARTY VIEW') {
        return false
      }
      else if (this.filter.groupby == "teamwise") {
        this.filter.incharger = row.incharger;
        this.filter.groupby = "agentwise";
      }
      else if (this.filter.groupby == "agentwise") {
        this.filter.agent_id = row.agent_id;
        this.filter.agent_name = row.agent_name;
        this.filter.groupby = "partywise";
      }
      else if (this.filter.groupby == "partywise") {
        this.filter.party_id = row.party_id;
        this.filter.party_name = row.party_name;
        this.filter.groupby = "dcwise";
      }
      else if (this.filter.groupby == "dcwise") {
        this.filter.dcid = row.dcid;
        this.filter.dc_no = row.dc_no;
        this.filter.groupby = "designwise";
      }



    }

    this.getShirtStockReport();
  }

  onbackbutton() {
    if (this.filter.stock_type == "SETWISE") {
      if (this.filter.groupby == "barcode") {
        this.filter.design_color = "";
        this.filter.groupby = "designColor";
      } else if (this.filter.groupby == "designColor") {
        this.filter.design_color = "";
        this.filter.groupby = "design";
      } else if (this.filter.groupby == "design") {
        this.filter.groupby = "variety";
        this.filter.design = "";
        this.filter.design_color = "";
      } else if (this.filter.groupby == "variety") {
        this.filter.stock_type = "total_stock";
        this.filter.groupby = "total_stock";
        this.filter.variety = "";
        this.filter.design = "";
        this.filter.design_color = "";
        this.filter.style = "";
      }
    } else if (
      this.filter.stock_type == "COREGANG" ||
      this.filter.stock_type == "DAMAGE"
    ) {
      if (this.filter.groupby == "barcode") {
        this.filter.design_color = "";
        this.filter.groupby = "designColor";
      } else if (this.filter.groupby == "designColor") {
        this.filter.groupby = "design";
        this.filter.design = "";
      } else if (this.filter.groupby == "design") {
        this.filter.groupby = "variety";
        this.filter.design_color = "";
        this.filter.variety = "";
      } else if (this.filter.groupby == "variety") {
        this.filter.groupby = "style";
        this.filter.design = "";
        this.filter.design_color = "";
        this.filter.style = "";
        this.filter.destype = "";

      } else if (this.filter.groupby == "style") {
        this.filter.stock_type = "total_stock";
        this.filter.groupby = "total_stock";
        this.filter.variety = "";
        this.filter.design = "";
        this.filter.design_color = "";
        this.filter.style = "";
        this.filter.type = "";
      }
    }
    else if (this.filter.stock_type == "CLUB") {
      if (this.filter.groupby == "barcode") {
        this.filter.design_color = "";
        this.filter.groupby = "designColor";
      } else if (this.filter.groupby == "designColor") {
        this.filter.groupby = "design";
        this.filter.design = "";
      } else if (this.filter.groupby == "design") {
        this.filter.stock_type = "total_stock";
        this.filter.groupby = "total_stock";
      }
    }

    else if (this.filter.stock_type == "OLIVE") {
      if (this.filter.groupby == "barcode") {
        this.filter.groupby = "total_stock";
        this.filter.stock_type = "total_stock";
      }
    }
    else if (this.filter.stock_type == "LIMIT STOCK") {
      if (this.filter.groupby == "barcode") {
        this.filter.groupby = "total_stock";
        this.filter.stock_type = "total_stock";
      }
    }
    else if (this.filter.stock_type == "SPECIAL GOODS") {
      if (this.filter.groupby == "barcode") {
        this.filter.groupby = "total_stock";
        this.filter.stock_type = "total_stock";
      }
    }
    else if (this.filter.stock_type == "BABLA") {
      if (this.filter.groupby == "barcode") {
        this.filter.groupby = "total_stock";
        this.filter.stock_type = "total_stock";
      }
    }
    else if (this.filter.stock_type == "LE MERITIN") {
      if (this.filter.groupby == "barcode") {
        this.filter.groupby = "total_stock";
        this.filter.stock_type = "total_stock";
      }
    }
    else if (this.filter.stock_type == "MARX") {
      if (this.filter.groupby == "barcode") {
        this.filter.groupby = "total_stock";
        this.filter.stock_type = "total_stock";
      }
    }
    else if (this.filter.stock_type == "RETURNBUNDLESTOCK") {
      if (this.filter.groupby == "bundle_entry") {
        this.filter.groupby = "total_stock";
        this.filter.stock_type = "total_stock";
      }
    } else if (
      this.filter.stock_type == "ESTIMATEBUNDLESTOCK" ||
      this.filter.stock_type == "ESTIMATESTOCK"
    ) {
      if (this.filter.groupby == "barcode") {
        this.filter.groupby = "invoice";
        this.filter.invoice_id = "";
      } else if (this.filter.groupby == "invoice") {
        this.filter.groupby = "party";
        this.filter.party_id = "";
      } else if (this.filter.groupby == "party") {
        this.filter.groupby = "agent";
        this.filter.agent_id = "";
      } else if (this.filter.groupby == "agent") {
        this.filter.groupby = "total_stock";
        this.filter.stock_type = "total_stock";
        this.filter.agent_id = "";
      }
    } else if (this.filter.stock_type == "IOSTOCK") {
      if (this.filter.groupby == "stockBarcodeType") {
        this.filter.groupby = "stockType";
        this.filter.aoid = "";
      } else if (this.filter.groupby == "stockType") {
        this.filter.groupby = "stock_outward";
        this.filter.outward_type = "";
      } else if (this.filter.groupby == "stock_outward") {
        this.filter.groupby = "total_stock";
        this.filter.stock_type = "total_stock";
      }
    } else if (this.filter.stock_type == "SIZEWISE") {
      if (this.filter.groupby == "barcode") {
        this.filter.design_color = "";
        this.filter.groupby = "designColor";
      } else if (this.filter.groupby == "designColor") {
        this.filter.design_color = "";
        this.filter.groupby = "design";
      } else if (this.filter.groupby == "design") {
        this.filter.groupby = "total_stock";
        this.filter.stock_type = "total_stock";
        this.filter.design = "";
        this.filter.design_color = "";
        this.filter.style = "";
      }
    }
    else if (this.filter.stock_type == 'COUNTER STOCK' || this.filter.stock_type == "COUNTERDC INWARD PENDING") {
      if (this.filter.groupby == "designwise") {
        this.filter.groupby = "dcwise";
        this.filter.dcid = "";
        this.filter.dc_no = "";

      } else if (this.filter.groupby == "dcwise") {
        this.filter.groupby = "partywise";
        this.filter.party_id = "";
      } else if (this.filter.groupby == "partywise") {
        this.filter.groupby = "agentwise";
        this.filter.agent_id = "";
        this.filter.agent_name = "";

      } else if (this.filter.groupby == "agentwise") {
        this.filter.groupby = "teamwise";
        this.filter.incharger = "";
      }
      else if (this.filter.groupby == "teamwise") {
        this.filter.groupby = "total_stock";
        this.filter.stock_type = "total_stock";

      }
    }

    this.getShirtStockReport();
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    
    if(this.filter.view_type){
      this.filterPanel.close();
    this.getShirtStockReport();
   
    }
  }
  removeElement(){
    this.filter.view_type = ''
  }
  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
    });
  }

  finyearCombo() {
    let that = this;
    this.combo2Service.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      that.finyearCtrl.setValue(res.data[0].fin_id);
      this.getShirtStockReport();
    });
  }

  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    if (comboType == "Finyear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  getShirtStockReport(): void {
    let params = {
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    that.isLoadMask = that.salesOrderServ
      .getShirtStockReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        let temp = 0;
        res.data.forEach((element, ind) => {
          if (ind >= 10) {
            temp = temp + 1;
            if (temp == 10) {
              temp = 0;
            }

            element["background"] = that.colorList[temp];

          }
          else
            element["background"] = that.colorList[ind];

        });

        if (that.filter.stock_type == "total_stock") {
          let colorLength = that.colorList.length - 1;

          let groupStockList = res.data.reduce((res, cur) => {
            (res[cur["groupes"]] = res[cur["groupes"]] || []).push(cur);
            return res;
          }, {});

          that.group1 = {
            total_pcs: 0,
            total_value: 0,
          };
          that.group2 = {
            total_pcs: 0,
            total_value: 0,
          };
          that.group3 = {
            total_pcs: 0,
            total_value: 0,
          };

          groupStockList["group1"].forEach((el) => {
            that.group1.total_pcs += el.total_pcs;
            that.group1.total_value += el.total_value;
          });

          groupStockList["group2"].forEach((el) => {
            that.group2.total_pcs += el.total_pcs;
            that.group2.total_value += el.total_value;
          });

          groupStockList["group3"].forEach((el) => {
            that.group3.total_pcs += el.total_pcs;
            that.group3.total_value += el.total_value;
          });

          // for(ar in arr){
          //   arr[ar].reduce((res, cur) => {
          //     return {pcs : cur.total_pcs + res.pcs}
          //   }, {});
          // }
        }

        that.page.count = res.totCnt;
        that.orderList = res.data;
        that.columnList = res.columns;

        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };
        that.printConfig = {
          title: "Cutting Report",
          columns: res.columns,
          rows: that.orderList,
        };
        that.exceldata = that.getData(res.columns, res.data);
        that.backbutton();
      });
  }

  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/shirtStockReport/shirtStockReport.ts